import './am-allocation-role-list.css';
import AmAllocationRoleList from './am-allocation-role-list';

const amAllocationRoleListInit = () => {
    customElements.define('am-allocation-role-list', AmAllocationRoleList);
};

export default amAllocationRoleListInit;
